import React, { FC, HTMLAttributes } from 'react';

export type TWhAntdIconProps = Pick<
  HTMLAttributes<HTMLSpanElement>,
  'style' | 'className'
>;

// These waste-fraction glyphs are WasteHero's own SVG artwork (each SVG is
// authored at 1em / currentColor). They were previously rendered through
// antd's `Icon` factory purely as a wrapping mechanism; this local wrapper
// keeps the identical markup — a `.anticon` span, so antd's global icon CSS
// and the `.anticon + span` tag spacing still apply — without importing
// `@ant-design/icons`.
export const createAntdIcon =
  (Svg: FC) =>
  ({ className, style }: TWhAntdIconProps) => (
    <span
      role="img"
      className={['anticon', className].filter(Boolean).join(' ')}
      style={style}
    >
      <Svg />
    </span>
  );
